import script from "./AuthorizedSignatoryDetailsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizedSignatoryDetailsList.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizedSignatoryDetailsList.vue?vue&type=style&index=0&id=0245a20a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0245a20a"]])

export default __exports__